var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "answers_block" }, [
    _c("div", { staticClass: "button_add mb-4" }, [
      _c(
        "button",
        {
          staticClass:
            "btn btn-md btn-block btn-outline-info waves-effect waves-themed",
          on: {
            click: function ($event) {
              return _vm.add_camera()
            },
          },
        },
        [
          _c("span", { staticClass: "fal fa-eject mr-1" }),
          _vm._v("\n\t\t\tДодати\n\t\t"),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "inf answers" },
      [
        _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
          _vm.items.length > 0
            ? _c("div", [
                _c(
                  "ul",
                  {
                    staticClass: "pl-0",
                    staticStyle: { "list-style": "none" },
                  },
                  _vm._l(_vm.items, function (item, idx) {
                    return _c(
                      "li",
                      { staticClass: "mt-2 list-style-none p-4 card" },
                      [
                        _c("div", { staticClass: "form-group" }, [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.axon_url,
                                  expression: "item.axon_url",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                placeholder: "URL camera",
                                type: "text",
                              },
                              domProps: { value: item.axon_url },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    item,
                                    "axon_url",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group-append" }, [
                              _c("div", { staticClass: "input-group-text" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control d-flex custom-switch",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.is_plate,
                                          expression: "item.is_plate",
                                        },
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        id: "eventlog-switch-" + idx,
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        checked: Array.isArray(item.is_plate)
                                          ? _vm._i(item.is_plate, null) > -1
                                          : item.is_plate,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = item.is_plate,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  item,
                                                  "is_plate",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  item,
                                                  "is_plate",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(item, "is_plate", $$c)
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "custom-control-label fw-500",
                                        attrs: {
                                          for: "eventlog-switch-" + idx,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t\t\tРозпізнання *\n\t\t\t\t\t\t\t\t\t\t\t"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "input-group flex-nowrap" },
                                [
                                  _c("b-form-radio-group", {
                                    staticClass: "input-group-text",
                                    attrs: {
                                      id: "btn-radios-" + idx,
                                      options: [
                                        { text: "IN", value: "in" },
                                        { text: "OUT", value: "out" },
                                      ],
                                      name: "radios-btn-default" + idx,
                                    },
                                    model: {
                                      value: item.direction,
                                      callback: function ($$v) {
                                        _vm.$set(item, "direction", $$v)
                                      },
                                      expression: "item.direction",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-danger",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.remove_camera(idx)
                                    },
                                  },
                                },
                                [_vm._v("Видалити")]
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }